import { manufacturingFetch } from "@/lib/manufacturingClient";
import type { ComposeArchetypeDraft } from "@/lib/manufacturing/composeArchetypeDraft";

export type ComposeArchetypeExtractResponse = {
  ok: true;
  draft: ComposeArchetypeDraft;
  outcome: string;
  source: "llm" | "heuristic";
};

export function extractComposeArchetype(payload: {
  transcript: string;
  size_axis_hint?: string;
}) {
  return manufacturingFetch<ComposeArchetypeExtractResponse>(
    "/api/mfg/compose/extract-archetype",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    },
  );
}
